import React from 'react';

export const SunburstRays = ({
  className = '',
  position = 'center',
  size = 'large',
  speed = 'slow',
  opacity = 0.15
}) => {
  const positions = {
    center: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
    'top-left': '-top-1/4 -left-1/4',
    'top-right': '-top-1/4 -right-1/4',
    'bottom-left': '-bottom-1/4 -left-1/4',
    'bottom-right': '-bottom-1/4 -right-1/4',
  };

  const sizes = {
    small: 'w-[100vw] h-[100vw] min-w-[800px] min-h-[800px]',
    medium: 'w-[150vw] h-[150vw] min-w-[1200px] min-h-[1200px]',
    large: 'w-[200vw] h-[200vw] min-w-[1600px] min-h-[1600px]',
    xlarge: 'w-[250vw] h-[250vw] min-w-[2000px] min-h-[2000px]',
  };

  const speeds = {
    slow: 'animate-spin-slow-60',
    medium: 'animate-spin-slow-40',
    fast: 'animate-spin-slow-20',
  };

  return (
    <div
      className={`absolute ${positions[position]} ${sizes[size]} pointer-events-none overflow-hidden ${className}`}
      style={{ opacity }}
    >
      <div className={`w-full h-full ${speeds[speed]}`}>
        <svg
          viewBox="0 0 800 800"
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient id="fadeGradient" cx="40%" cy="50%" r="50%">
              <stop offset="0%" stopColor="white" stopOpacity="1" />
              <stop offset="100%" stopColor="white" stopOpacity="0" />
            </radialGradient>
            <mask id="rayMask">
              <rect width="100%" height="100%" fill="url(#fadeGradient)" />
            </mask>
          </defs>

          {/* Generate 24 rays */}
          <g mask="url(#rayMask)">
            {Array.from({ length: 24 }, (_, i) => {
              const angle = (i * 360) / 24;
              return (
                <g key={i} transform={`rotate(${angle} 400 400)`}>
                  <polygon
                    points="400,400 430,-200 370,-200"
                    fill={i % 2 === 0 ? "#f4d908ff" : "#ef6728"}
                    opacity="1"
                  />
                </g>
              );
            })}
          </g>

          {/* Center circle removed for sharp sunburst */}
        </svg>
      </div>
    </div>
  );
};